import PropTypes from 'prop-types';
import { cn } from '@/lib/utils';

export function StarsBackground({ className, starColor = '#24552d' }) {
  const starStyle = { color: starColor };

  return (
    <div
      aria-hidden="true"
      className={cn('pointer-events-none overflow-hidden', className)}
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(19,131,58,0.16),_transparent_22%),radial-gradient(circle_at_top_right,_rgba(245,200,0,0.15),_transparent_24%),radial-gradient(circle_at_bottom_left,_rgba(19,131,58,0.12),_transparent_24%),radial-gradient(circle_at_bottom_right,_rgba(245,200,0,0.14),_transparent_22%)]" />
      <div className="absolute inset-y-0 left-0 w-[14vw] min-w-[72px] bg-[radial-gradient(circle_at_left_center,_rgba(19,131,58,0.18),_transparent_70%)] blur-2xl" />
      <div className="absolute inset-y-0 right-0 w-[14vw] min-w-[72px] bg-[radial-gradient(circle_at_right_center,_rgba(245,200,0,0.18),_transparent_70%)] blur-2xl" />

      {[
        'left-[3%] top-[12%]',
        'left-[6%] top-[28%]',
        'left-[4%] top-[56%]',
        'left-[7%] top-[78%]',
        'right-[4%] top-[10%]',
        'right-[7%] top-[26%]',
        'right-[5%] top-[52%]',
        'right-[6%] top-[80%]',
      ].map((position, index) => (
        <span
          key={position}
          style={starStyle}
          className={cn(
            'absolute text-[10px] opacity-60',
            position,
            index % 2 === 0 ? 'animate-pulse' : 'animate-[pulse_4s_ease-in-out_infinite]'
          )}
        >
          {'\u2726'}
        </span>
      ))}
    </div>
  );
}

StarsBackground.propTypes = {
  className: PropTypes.string,
  starColor: PropTypes.string,
};
